import { render } from "./BarcodeListPage.vue?vue&type=template&id=4472dbca&scoped=true"
import script from "./BarcodeListPage.vue?vue&type=script&lang=ts"
export * from "./BarcodeListPage.vue?vue&type=script&lang=ts"

import "./BarcodeListPage.vue?vue&type=style&index=0&id=4472dbca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4472dbca"

export default script